import React from 'react'
import PropTypes from 'prop-types'

import MenuItem from './MenuItem'

export default class SettingsMenu extends React.Component {

  static propTypes = {
    selectionId: PropTypes.string.isRequired,
    onOptionClicked: PropTypes.func.isRequired
  }

  render() {
    return (
      <div style={styles.container}>
        <MenuItem display='General'
          style={styles.item}
          onOptionClicked={() => this.props.onOptionClicked('general')}
          selected={this.props.selectionId === 'general'}>
          <MenuItem display='Daily emails'
            onOptionClicked={() => this.props.onOptionClicked('daily_emails')}
            level={1}
            selected={this.props.selectionId === 'daily_emails'} />
          <MenuItem display='Calendar'
            onOptionClicked={() => this.props.onOptionClicked('calendar')}
            level={1}
            selected={this.props.selectionId === 'calendar'} />
          <MenuItem display='Materials'
            onOptionClicked={() => this.props.onOptionClicked('materials')}
            level={1}
            selected={this.props.selectionId === 'materials'} />
          <MenuItem display='Invoice items'
            onOptionClicked={() => this.props.onOptionClicked('invoice_items')}
            level={1}
            selected={this.props.selectionId === 'invoice_items'} />
          <MenuItem display='Organization logo'
            onOptionClicked={() => this.props.onOptionClicked('company_logo')}
            level={1}
            selected={this.props.selectionId === 'company_logo'} />
        </MenuItem>
        <MenuItem display='API'
          style={styles.item}
          onOptionClicked={() => this.props.onOptionClicked('api')}
          selected={this.props.selectionId === 'api'}>
          <MenuItem display='Keys'
            onOptionClicked={() => this.props.onOptionClicked('api_keys')}
            level={1}
            selected={this.props.selectionId === 'api_keys'}/>
        </MenuItem>
      </div>
    )
  }

}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column'
  },
  item: {
    marginTop: 15
  }
}



// WEBPACK FOOTER //
// ./src/settings/SettingsMenu.js